import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaperPlane: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="paper-plane, send"><path d="M3.02054 2.92331C3.25067 2.73196 3.57254 2.69576 3.83943 2.8312L20.5894 11.3312C20.8413 11.459 21 11.7175 21 12C21 12.2825 20.8413 12.541 20.5894 12.6688L3.83943 21.1688C3.57254 21.3043 3.25067 21.2681 3.02054 21.0767C2.7904 20.8854 2.69606 20.5755 2.78051 20.2884L4.99768 12.75H9.25004C9.66426 12.75 10 12.4142 10 12C10 11.5858 9.66426 11.25 9.25004 11.25H4.99768L2.78051 3.71163C2.69606 3.4245 2.7904 3.11465 3.02054 2.92331Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPaperPlane;
